/* ============================================================
   Section: Slideshow (Hero) — Jayone redesign
   ============================================================
   Re-syncs PC/mobile hero background videos when the viewport
   crosses the 768px breakpoint after the page has already loaded.

   Why: a <video><source media="..."> only picks a source ONCE,
   at initial load/.load() — unlike <picture>, it does not
   re-evaluate automatically on resize. Without this, a hero video
   picked at desktop width keeps playing the desktop file even
   after the browser window is resized down to mobile width (and
   vice versa), which looks like "the mobile video never applies".
   ============================================================ */
(function () {
  var mql = window.matchMedia('(max-width: 767px)');

  function resyncResponsiveHeroVideos() {
    document.querySelectorAll('slideshow-component video[data-video-autoplay]').forEach(function (video) {
      if (video.querySelectorAll('source[media]').length < 2) return;

      var wasPlaying = !video.paused;
      video.load();
      if (wasPlaying) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }
    });
  }

  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', resyncResponsiveHeroVideos);
  } else if (typeof mql.addListener === 'function') {
    mql.addListener(resyncResponsiveHeroVideos);
  }
})();
